// extracted by mini-css-extract-plugin
module.exports = {"languageFont":"styles_languageFont_LczkoG0tApT352A4Gy6M","spin":"styles_spin_4ck9c5Bp4aRdDXX_-SPS8"};